import moment from 'moment-timezone';
import { yearSuffixes } from './tourDateRange';

// Check-out chip text for a conversation row. Only a booking that owns its end (a
// hotel stay) has subject_checkout_ts; a booking that ends at start + tour length
// ends with the trip, which the channel header already shows, so it gets no chip.
// Shown on the tour's clock, like the Users grid Check-out column and the picker.
export function checkoutLabel(checkoutTs, timeZone, now = moment()) {
    if (!checkoutTs) {
        return null;
    }
    const zone = timeZone || 'UTC';
    const checkout = moment.utc(checkoutTs).tz(zone);
    if (!checkout.isValid()) {
        return null;
    }
    const past = checkout.isSameOrBefore(now);
    const full = `${checkout.format('dddd, MMMM D, YYYY h:mm A')} (${zone})`;
    return past
        ? { past, label: `Checked out ${checkout.format('MMM D')}`, tooltip: `Checked out: ${full}` }
        : { past, label: `Check-out ${checkout.format('MMM D, h:mm A')}`, tooltip: `Check-out: ${full}` };
}

// Chat screen header: the guest's check-out TIME only, since the header's date range
// already ends on that day. Same past/future wording and tooltip as checkoutLabel.
export function checkoutTimeLabel(checkoutTs, timeZone, now = moment()) {
    const full = checkoutLabel(checkoutTs, timeZone, now);
    if (!full) {
        return null;
    }
    const time = moment.utc(checkoutTs).tz(timeZone || 'UTC').format('h:mm A');
    return { ...full, label: `${full.past ? 'Checked out' : 'Check-out'} ${time}` };
}

// A hotel channel's date label when its guests check out on different days, e.g.
// "OCT 8 · CHECK-OUTS OCT 10–12". The channel's end is its LAST guest's check-out,
// so "OCT 8 – OCT 12" read as if everyone left on the 12th. Null when there is no
// check-out spread or every check-out falls on one tour day: the plain range is
// right then. Uppercase to match the chat lists' date ranges. Years appear on the
// same terms as tourDateRangeText: "DEC 28 '26 · CHECK-OUTS JAN 2–4 '27".
export function staggeredCheckoutText(startTs, spread, timeZone, now = moment()) {
    if (!startTs || !spread || !spread.first || !spread.last) {
        return null;
    }
    const zone = timeZone || 'UTC';
    const start = moment.utc(startTs).tz(zone);
    const first = moment.utc(spread.first).tz(zone);
    const last = moment.utc(spread.last).tz(zone);
    if (!start.isValid() || !first.isValid() || !last.isValid() || first.isSame(last, 'day')) {
        return null;
    }
    const [startYear, firstYear, lastYear] = yearSuffixes([start, first, last], zone, now);
    const lastText = last.isSame(first, 'month') ? last.format('D') : last.format('MMM D');
    return `${start.format('MMM D')}${startYear} · CHECK-OUTS ${first.format('MMM D')}${firstYear}–${lastText}${lastYear}`.toUpperCase();
}
